import { connect } from 'react-redux';
import { IStateType } from '../../../store/models/root.interface';
import ProfileSetting, { DispatchPropsType, MapStateType } from '../organisms';
import { closeSideBar } from '../../../store/sidebar/actions';
import { Instances } from '../../../constants';
import { makeSelectObjectsArray, requestObjects } from '../../../store/Objects';
import { makeSelectObject, requestObject } from '../../../store/Object';


const mapStateToProps = (state: IStateType) => ({
    profile: state.profile.fullProfile,
    timezoneData: makeSelectObjectsArray(Instances.timezones)(state) || [],
    photoS3LinkData: makeSelectObject(Instances.uploadPhoto)(state),

});
const mapDispatchToProps = {
    onClick: () => closeSideBar(),
    fetchTimezones: () => requestObjects(Instances.timezones, undefined, {}, false, false),
    uploadPhoto: (data: any, callBack: any) => requestObject(Instances.uploadPhoto, undefined, {}, 'post', true, true, data, callBack),
    saveProfileDetails: (data: any, callBack: any) => requestObject(Instances.saveProfileSetting, undefined, {}, 'put', true, true, data, callBack),
};

export default connect<MapStateType, DispatchPropsType, unknown, IStateType>(
    mapStateToProps,
    mapDispatchToProps
)(ProfileSetting);
